import React from 'react';
import { Clock3Icon, LanguagesIcon, ShieldCheckIcon, StarIcon, UsersIcon } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';
import { container } from '../../utils/styles';
const items = [{
  icon: ShieldCheckIcon,
  label: {
    en: 'Licensed & Insured',
    es: 'Licenciados y Asegurados'
  }
}, {
  icon: StarIcon,
  label: {
    en: '5-Star Rated',
    es: 'Calificación 5 Estrellas'
  }
}, {
  icon: UsersIcon,
  label: {
    en: 'Trusted by 500+ Families',
    es: 'Confianza de 500+ Familias'
  }
}, {
  icon: Clock3Icon,
  label: {
    en: '24/7 Available',
    es: 'Disponible 24/7'
  }
}, {
  icon: LanguagesIcon,
  label: {
    en: 'Se habla español',
    es: 'Personal Bilingüe'
  }
}];
export function TrustStrip() {
  const {
    t
  } = useLanguage();
  return <div className="border-b border-mist bg-white" data-id="element-67" data-mp="3v4sdv2kqd46k">
      <ul className={`${container} flex flex-wrap items-center justify-center gap-x-8 gap-y-3 py-6 lg:justify-between`} data-id="element-68" data-mp="wfk08nd3vje8">
        {items.map(item => {
        const Icon = item.icon;
        return <li key={item.label.en} className="flex items-center gap-2 font-semibold text-ink" data-id="element-69" data-mp="37holwzpslgam">
              <Icon className="h-5 w-5 shrink-0 text-sage-dark" aria-hidden="true" data-id="element-70" data-mp="3chaxl4pz2ohb" />
              {t(item.label)}
            </li>;
      })}
      </ul>
    </div>;
}